import TemplateColumns from './template-columns';
import SettingsColumn from './settings-column';

const NotificationSettingsColumns = () => (
  <>
    <TemplateColumns />
    <SettingsColumn />
  </>
);

export default NotificationSettingsColumns;
